export default {
  toastSuccessTitle: {
    id: 'product_card_add_to_cart_toast_title',
    defaultMessage: 'Added to cart',
  },
  toastSucessCta: {
    id: 'product_card_add_to_cart_toast_cta',
    defaultMessage: 'Go to cart',
  },
  toastErrorTitle: {
    id: 'cross_sell_toast_title_error',
    defaultMessage: 'Oops',
  },
  toastErrorMessage: {
    id: 'cross_sell_toast_message_error',
    defaultMessage: 'Product not added to the cart.',
  },
} as const
